/* Slabworks Vault — global.js
   Vanilla JS only. Modules: header, announcement, cart drawer (AJAX),
   product form, variant picker, gallery + zoom, collection filters,
   scroll reveal. */
(function () {
  'use strict';

  var money = function (cents) {
    var format = (window.slabworks && window.slabworks.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/<[^>]+>/g, '');
  };

  /* ---------- announcement bar ---------- */
  document.querySelectorAll('[data-announcement-close]').forEach(function (btn) {
    var bar = btn.closest('.announcement-bar');
    if (sessionStorage.getItem('sw-announcement-dismissed')) {
      bar.classList.add('is-dismissed');
    }
    btn.addEventListener('click', function () {
      bar.classList.add('is-dismissed');
      sessionStorage.setItem('sw-announcement-dismissed', '1');
    });
  });

  /* ---------- header ---------- */
  var header = document.querySelector('[data-header]');
  if (header && header.classList.contains('site-header--sticky')) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var open = mobileNav.hasAttribute('hidden');
      mobileNav.toggleAttribute('hidden', !open);
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-search-bar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      var open = searchBar.hasAttribute('hidden');
      searchBar.toggleAttribute('hidden', !open);
      if (open) searchBar.querySelector('input[type="search"]').focus();
    });
    var searchClose = searchBar.querySelector('[data-search-close]');
    if (searchClose) {
      searchClose.addEventListener('click', function () {
        searchBar.setAttribute('hidden', '');
        searchToggle.focus();
      });
    }
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastFocused = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var panel = drawer.querySelector('.cart-drawer__panel');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  function refreshDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html || !drawer) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer]');
        if (fresh) {
          var wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = fresh.innerHTML;
          if (wasOpen || openAfter) {
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
          }
        }
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.toggle('is-empty', cart.item_count === 0);
            });
          });
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && window.slabworks && window.slabworks.cartDrawerEnabled && drawer) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      var zoom = document.querySelector('[data-zoom-modal]:not([hidden])');
      if (zoom) zoom.setAttribute('hidden', '');
    }
  });

  /* cart line quantity + remove (event delegation, survives re-render) */
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var wrap = qtyBtn.closest('.qty');
      var input = wrap && wrap.querySelector('[data-qty-input]');
      if (input) {
        var next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(qtyBtn.dataset.qtyChange, 10));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) {
      updateLine(removeBtn.dataset.lineKey, 0);
    }
    var upsellBtn = e.target.closest('[data-upsell-add]');
    if (upsellBtn) {
      upsellBtn.disabled = true;
      addToCart(upsellBtn.dataset.variantId, 1).then(function () {
        upsellBtn.disabled = false;
      });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input][data-line-key]');
    if (input) {
      updateLine(input.dataset.lineKey, Math.max(0, parseInt(input.value, 10) || 0));
    }
  });

  function updateLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { return refreshDrawer(false); });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      if (window.slabworks && window.slabworks.cartDrawerEnabled && drawer) {
        return refreshDrawer(true);
      }
      window.location.href = '/cart';
    });
  }

  /* ---------- product form ---------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      if (!(window.slabworks && window.slabworks.cartDrawerEnabled && drawer)) return;
      e.preventDefault();
      var btn = productForm.querySelector('[data-atc-button]');
      var label = productForm.querySelector('[data-atc-label]');
      var original = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = '…';
      var id = productForm.querySelector('[data-variant-id-input]').value;
      var qty = parseInt(productForm.querySelector('[name="quantity"]').value, 10) || 1;
      addToCart(id, qty)
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () {
          if (btn) btn.disabled = false;
          if (label) label.textContent = original;
        });
    });
  }

  /* ---------- variant picker ---------- */
  var picker = document.querySelector('[data-variant-picker]');
  if (picker && productForm) {
    var variantData = [];
    try {
      variantData = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
    } catch (err) { /* no variants */ }

    picker.addEventListener('change', function () {
      var selected = [];
      picker.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        selected[parseInt(fieldset.dataset.optionIndex, 10)] = checked ? checked.value : null;
      });
      var match = variantData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      var idInput = productForm.querySelector('[data-variant-id-input]');
      var btn = productForm.querySelector('[data-atc-button]');
      var label = productForm.querySelector('[data-atc-label]');
      var priceWrap = document.querySelector('[data-price-wrapper] .price__current');
      if (match) {
        idInput.value = match.id;
        if (priceWrap) priceWrap.textContent = money(match.price);
        if (btn && label) {
          btn.disabled = !match.available;
          label.textContent = match.available
            ? (btn.dataset.labelAdd || 'Add to cart')
            : (btn.dataset.labelSold || 'Sold out');
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState(null, '', url.toString());
        }
        if (match.featured_media) {
          var fig = document.querySelector('[data-media-id="' + match.featured_media.id + '"]');
          if (fig) activateMedia(match.featured_media.id);
        }
      } else if (btn && label) {
        btn.disabled = true;
        label.textContent = btn.dataset.labelUnavailable || 'Unavailable';
      }
    });
  }

  /* ---------- gallery ---------- */
  function activateMedia(id) {
    document.querySelectorAll('.product__media').forEach(function (fig) {
      fig.classList.toggle('is-active', fig.dataset.mediaId === String(id));
    });
    document.querySelectorAll('.product__thumb').forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.thumbFor === String(id));
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-for]');
    if (thumb) activateMedia(thumb.dataset.thumbFor);

    var zoomTrigger = e.target.closest('[data-zoom-src]');
    if (zoomTrigger) {
      var modal = document.querySelector('[data-zoom-modal]');
      if (modal) {
        var img = modal.querySelector('[data-zoom-img]');
        img.src = zoomTrigger.dataset.zoomSrc;
        img.alt = (zoomTrigger.querySelector('img') || {}).alt || '';
        modal.removeAttribute('hidden');
        modal.querySelector('[data-zoom-close]').focus();
      }
    }
    if (e.target.closest('[data-zoom-close]') || e.target.matches('.product-zoom__img')) {
      var openModal = document.querySelector('[data-zoom-modal]:not([hidden])');
      if (openModal) openModal.setAttribute('hidden', '');
    }
  });

  /* ---------- collection filters / sort ---------- */
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    var sortSelect = filterForm.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit();
      });
    }
    filterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams();
      new FormData(filterForm).forEach(function (value, name) {
        if (value !== '') params.append(name, value);
      });
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  }

  /* ---------- scroll reveal ---------- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduced && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll('.pcard, .need-tile, .trust-band__item, .spotlight__body, .faq__item');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (t, i) {
      t.setAttribute('data-reveal', '');
      t.style.transitionDelay = Math.min(i % 4, 3) * 60 + 'ms';
      io.observe(t);
    });
  }
})();
